/**
 * Created by lihanying on 2017/7/5.
 */
import React from 'react'
import Alter from './alter'
import ClubInfo from './clubInfo'
import Wallet from './wallet'
import { ContactsOutlined, IdcardOutlined } from '@ant-design/icons'
import { Modal, Tabs, Input } from 'antd'
const TabPane = Tabs.TabPane

export default class extends React.Component {
  render() {
    const { visible, club_name, club_id, clubInfo, walletInfo, walletRecord } =
      this.props
    return (
      <div>
        <Modal
          title={club_name}
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="800px"
        >
          <Tabs defaultActiveKey="1" onTabClick={this.onTabClick}>
            <TabPane
              tab={
                <span>
                  <IdcardOutlined />
                  资料
                </span>
              }
              key="1"
            >
              <ClubInfo {...clubInfo} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <ContactsOutlined />
                  钱包
                </span>
              }
              key="2"
            >
              <Wallet
                club_id={club_id}
                wallet={walletInfo}
                walletRecord={walletRecord}
                fetchWalletRecord={this.props.fetchWalletRecord}
              />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <ContactsOutlined />
                  修改
                </span>
              }
              key="3"
            >
              {clubInfo.id && <Alter clubInfo={clubInfo} />}
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubList/component/modalInfo.js